export const integrationEventNames = {
    ORDER_PROCESSED: 'order-processed',
    CONTACT_SENT: 'contact-sent',
    INTEGRATION_CONNECTED: 'integration-connected',
    INTEGRATION_UPDATED: 'integration-updated',
    ERROR_CONNECTION: 'error-connection',
    ERROR_REQUIRED_MERGE_FIELDS: 'error-required-merge-fields',
    ERROR_LIST_NOT_FOUND: 'error-list-not-found',
    XERO_CONTACT_CREATED: 'xero-contact-created',
    XERO_INVOICE_CREATED: 'xero-invoice-created',
    XERO_BILL_CREATED: 'xero-bill-created',
    XERO_PAYMENT_CREATED: 'xero-payment-created',
    SHOPIFY_PAYOUT_MADE: 'shopify-payout-made',
    BANK_TRANSFER_FROM_CLEARING_ACCOUNT: 'bank-transfer-from-clearing-account',
    BANK_TRANSFER_TO_CLEARING_ACCOUNT: 'bank-transfer-to-clearing-account',
    BANK_ACCOUNT_MAPPED: 'bank-account-mapped',
    BANK_ACCOUNT_UPDATED: 'bank-account-mapping-updated',
    BANK_ACCOUNT_NOT_FOUND: 'bank-account-not-found',
    BANK_ACCOUNT_NOT_FOUND_RESOLVED: 'bank-account-not-found-resolved',
    CLEARING_ACCOUNT_CREATED: 'clearing-account-created',
    CLEARING_ACCOUNT_MAPPED: 'clearing-account-mapped',
    CLEARING_ACCOUNT_UPDATED: 'clearing-account-mapping-updated',
    CLEARING_ACCOUNT_NOT_FOUND: 'clearing-account-not-found',
    CLEARING_ACCOUNT_NOT_FOUND_RESOLVED: 'clearing-account-not-found-resolved',
    CHART_OF_ACCOUNT_MAPPED: 'chart-of-account-mapped',
    CHART_OF_ACCOUNT_CREATED: 'xero-chart-of-account-created',
    CHART_OF_ACCOUNT_UPDATED: 'chart-of-account-mapping-updated',
    CHART_OF_ACCOUNT_NOT_FOUND: 'chart-of-account-not-found',
    CHART_OF_ACCOUNT_NOT_FOUND_RESOLVED: 'chart-of-account-not-found-resolved',
    INVOICE_CONTACT_CREATED: 'xero-invoice-contact-created',
    CONTACT_NOT_FOUND: 'contact-not-found',
    CONTACT_NOT_FOUND_RESOLVED: 'contact-not-found-resolved',
    INVOICE_LIMIT_REACHED: 'invoice-limit-reached',
    INVOICE_LIMIT_REACHED_RESOLVED: 'invoice-limit-reached-resolved',
    INSUFFICIENT_USER_PERMISSIONS: 'insufficient-user-permissions',
    INSUFFICIENT_USER_PERMISSIONS_RESOLVED: 'insufficient-user-permissions-resolved',
    FREE_TRIAL_STARTED: 'free-trial-started',
    FREE_TRIAL_EXPIRED: 'free-trial-expired',
    FREE_TRIAL_EXPIRED_RESOLVED: 'free-trial-expired-resolved',
    TAX_RATE_MAPPED: 'tax-rate-mapped',
    TAX_RATE_UPDATED: 'tax-rate-mapping-updated',
    TAX_RATE_NOT_FOUND: 'tax-rate-not-found',
    TAX_RATE_NOT_FOUND_RESOLVED: 'tax-rate-not-found-resolved',
    TAX_RATE_INCORRECT: 'tax-rate-incorrect',
    TAX_RATE_INCORRECT_RESOLVED: 'tax-rate-incorrect-resolved',
    MISSING_TRANSACTION_TYPE_MAPPING: 'missing-transaction-type-mapping',
    MISSING_TRANSACTION_TYPE_MAPPING_RESOLVED: 'missing-transaction-type-mapping-resolved',
    TRANSACTION_IMPORT_RESUMED: 'transaction-import-resumed',
};
